import { Box, Flex } from "@acko-tech/building-blocks.ui.common";
import { useContext, useState } from "react";
import { Context } from "@components/useContext/context";
import { Text } from "@acko-tech/building-blocks.ui.typography";
import { useOnload } from "@utils/useOnLoad";
import DOMPurify from "isomorphic-dompurify";

import { convertToLakhMin } from "@utils/inrFormatter";
import { Container } from "./styles";
import { resolvePath } from "@utils/resolvePath";
import CloneChildren from "@components/children";
import ImageContainer from "@components/imageContainer";

const IdvSelection = ({ children, ...props }) => {
  const {
    idv_value,
    text,
    displayText,
    src,
    styles,
    actions,
    is_visible,
    childrenStyles,
    showIdvSlabs,
    maxIdvText
  } = props;
  const { on_load } = actions || {};

  useOnload({ on_load });
  return is_visible ? (
    <Box>
      <Flex style={{ flexDirection: "column" }}>
        {displayText && (
          <Text
            styles={styles}
            style={{
              fontSize: "16px",
              fontWeight: 400,
              lineHeight: "24px",
              display: "inline",
              color: "#040222"
            }}
          >
            {displayText} -{" "}
            <span style={{ fontWeight: 600, color: "#040222" }}>
              {" "}

              ₹{convertToLakhMin(idv_value)} lakh

            </span>
          </Text>
        )}
        {text && (
          !showIdvSlabs ? (
          <Container>
             <ImageContainer
                  imgSrc={src}
                  width={48}
                  height={48}
                  alt="icon"
                />
            <div
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(maxIdvText) }}
            />
          </Container>
        ):(
          <Container>
             <ImageContainer
                  imgSrc={src}
                  width={48}
                  height={48}
                  alt="icon"
                />
            <div
              dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text) }}
            />
          </Container>
        ))}
      </Flex>

      <CloneChildren
        children={children}
        styles={childrenStyles}
      ></CloneChildren>
    </Box>
  ) : null;
};

export default IdvSelection;
